import {Location} from "../../objects/management/locationManagement/location";

/**
 * Created by vlad.p on 10/12/2017.
 */

export class LocationUpdateRequest {

    public ChangeOrders: boolean;
    public Location: Location;

    constructor(obj: Partial<LocationUpdateRequest>) {
        Object.assign(this, obj);
    }

}


// WEBPACK FOOTER //
// ./app/objects/requests/locationUpdateRequest.ts